import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'consecutiveZeros',
  standalone: true,
})
export class ConsecutiveZerosPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';

    const matches = value.match(/0+/g);
    if (!matches) return value;

    const maxConsecutive = Math.max(...matches.map((m) => m.length));

    return maxConsecutive > 6
      ? `${value} </br> (<strong>${maxConsecutive}</strong> x 0)`
      : value;
  }
}
